export default {
  intranetHost: 'th.lcp.jdl.com',
  gatewayOuterBaseApi: 'https://intl-api.jdl.com/',
  gatewayBaseApi: 'http://intl-lop.jdl.com/',
  gatewayFileBaseApi: 'http://intl-lop.jdl.com/',
  domainErp: '//ssa.jd.com',
  gatewayApiDecoupling: 'http://intl-lop.jdl.com',
  jingMeAuthAlias: 'lop-intl-us'
}
